import { BsThreeDotsVertical } from 'react-icons/bs';
import { GoPlusSmall } from 'react-icons/go';
import { MdKeyboardArrowRight } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as DefaultCardIcon } from 'assets/images/payment-card-default.svg';

interface ContainerProps {
  twoColumns?: boolean;
  multipleColumns?: boolean;
}

export interface HeaderProps {
  empty: boolean;
  twoColumns: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background-color: ${({ theme }) => theme.listPreviewCard.white};
  height: fit-content;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ multipleColumns, twoColumns }) => (!multipleColumns || twoColumns ? 'none' : 'calc(50% - 16px)')};
  }
`;

export const Header: any = styled.div<HeaderProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  height: 82px;
  cursor: pointer;
  font-size: 12px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ twoColumns }) => (twoColumns ? 'calc(50% - 16px)' : 'none')};
  }

  & > div {
    color: ${({ theme }) => theme.group.subTitle};
  }
`;

Header.Placeholder = styled.span.attrs<any, HeaderProps>((): any => ({}))`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme, empty }) =>
    empty ? theme.listPreviewCard.fontColor.empty : theme.listPreviewCard.fontColor.active};
`;

Header.Title = styled.span`
  line-height: 1.5;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.group.subTitle};
`;

Header.Icon = styled.img`
  height: 48px;
  width: 48px;
  margin-right: 14px;
  object-fit: contain;
`;

Header.Flag = styled.div`
  width: 48px;
  margin-right: 14px;
  position: relative;
`;

interface FlagProps {
  src: string;
}

Header.FlagImage = styled.div.attrs<any, FlagProps>((): any => ({}))`
  width: 20px;
  height: 13px;
  position: absolute;
  bottom: -2px;
  right: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${({ src }) => `url(${src})`};
  background-size: cover;
  border-radius: 2px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
`;

Header.PlusIcon = styled(GoPlusSmall).attrs<any, HeaderProps>((): any => ({}))`
  height: 28px;
  width: 28px;
  color: ${({ theme, empty }) =>
    empty ? theme.listPreviewCard.fontColor.empty : theme.listPreviewCard.fontColor.active} !important;
  margin-left: auto;
`;

Header.ArrowIcon = styled(MdKeyboardArrowRight).attrs<any, HeaderProps>((): any => ({}))`
  height: 20px;
  width: 20px;
  color: ${({ theme, empty }) =>
    empty ? theme.listPreviewCard.fontColor.empty : theme.listPreviewCard.fontColor.active} !important;
  margin-left: auto;
`;

Header.DotsIcon = styled(BsThreeDotsVertical).attrs<any, HeaderProps>((): any => ({}))`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.listPreviewCard.fontColor.empty};
  margin-left: auto;
`;

Header.Detail = styled.div`
  display: flex;
  width: 100%;
  flex: 2;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;

  & > div {
    font-size: 12px;
    line-height: 1.5em;
    color: ${ColorPalette.HEX.Manatee};
  }
`;

Header.DefaultCard = styled(DefaultCardIcon)`
  width: 24px;
  margin-right: 10px;
  height: 24px;
  color: ${ColorPalette.HEX.GreenPantone2};
`;
